import { render } from "./ApprovedUsers.vue?vue&type=template&id=7bf60b69&scoped=true"
import script from "./ApprovedUsers.vue?vue&type=script&lang=js"
export * from "./ApprovedUsers.vue?vue&type=script&lang=js"

import "./ApprovedUsers.vue?vue&type=style&index=0&id=7bf60b69&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf60b69"]])

export default __exports__